import {
  MerchantAppReturnZodSchema,
  MerchantAppReturnZodSchema_,
} from "@redotech/redo-model/return";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const InitialReturnUpdate_ = z.object({
  type: z.literal("initial"),
  data: MerchantAppReturnZodSchema,
});

const PartialReturnUpdate_ = z.object({
  type: z.literal("update"),
  updatedFields: z.partialRecord(z.keyof(MerchantAppReturnZodSchema_), z.any()),
});

export const watchReturn = unaryStreamRpc({
  name: "watchReturn",
  input: z.object({ returnId: z.string() }),
  output: z.discriminatedUnion("type", [
    InitialReturnUpdate_,
    PartialReturnUpdate_,
  ]),
});
